import React from 'react';
import styles from '../../assets/CommonScss/DeleteConfirmModule.module.scss';
import DeleteIcon from '../../assets/images/delete.png';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <img src={DeleteIcon} alt="Delete Confirm" className={styles.image} />
        <h2 className={styles.title}>Are You Sure?</h2>
        <p className={styles.message}>
          You want to delete this content record from database? It cannot be restored.
        </p>
        <div className={styles.buttons}>
          <button className={styles.cancelBtn} onClick={onClose}>Cancel</button>
          <button className={styles.confirmBtn} onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
